import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import guestSlice from "./guestSlice";
import serverSlice from "./serverSlice";

const store = configureStore({
    reducer: {
        userStore: userSlice,
        guestStore: guestSlice,
        serverStore: serverSlice,
    },
});

export default store;
